// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kLnVOI {
  background: var(--surface-neutral-white);
  border-radius: var(--radius-m);
  box-shadow: var(--shadow-s);
  height: calc(100vh - 155px);
  min-height: 360px;
  position: relative;
}

.paTqWq {
  padding: var(--spacing-3) var(--spacing-3) var(--spacing-2);
  border-bottom: 1px solid var(--stroke-neutral-subtle);
}

.Z_7cWv {
  color: var(--text-neutral-dark);
  font-size: var(--type-title-md-font-size);
  font-weight: var(--font-weight-regular);
  line-height: var(--type-label-lg-regular-line-height);
  margin: 0;
}

.yJsS5O {
  height: 1px;
  background-color: var(--stroke-neutral-soft);
}

.wLAnoX {
  padding: var(--spacing-3);
}

.FMyVpu {
  margin-bottom: var(--spacing-3);
}

.FMyVpu:last-child {
  margin-bottom: 0;
}

.ioRCk4 {
  display: flex;
  align-items: center;
  gap: var(--spacing-1-5);
  margin-bottom: var(--spacing-2);
}

.lMVIjF {
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--spacing-3);
  height: var(--spacing-3);
}

.iS1UXz,
.UmcFkm {
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--spacing-3);
  height: var(--spacing-3);
  border-radius: var(--spacing-1-5);
  font-size: var(--type-label-md-font-size);
  font-weight: var(--type-label-md-font-weight);
  line-height: 1;
}

.iS1UXz {
  background: var(--icon-primary-medium);
  color: var(--text-neutral-white);
  height: var(--spacing-3);
  width: var(--spacing-3);
}

.TE_RZe {
  color: var(--status-success);
  height: var(--spacing-3);
  width: var(--spacing-3);
}

.UmcFkm {
  background-color: transparent;
  border: 1px solid var(--text-neutral-strong);
  color: var(--text-neutral-strong);
}

.oAfh2v,
.RFUnRX {
  font-size: var(--type-title-md-font-size);
  font-weight: var(--type-paragraph-lg-regular-font-weight);
  line-height: var(--type-label-lg-regular-line-height);
}

.oAfh2v {
  color: var(--text-neutral-dark);
}

.RFUnRX {
  color: var(--disabled-subtle-text);
}

.LDnB0W {
  height: 1px;
  background-color: var(--stroke-neutral-subtle);
  margin: var(--spacing-2) 0;
}

.xO4_ZZ {
  margin: var(--spacing-3) 0;
}

.Tn6RtP {
  align-items: center;
  display: flex;
  margin-bottom: var(--spacing-1);
}

.Tn6RtP:last-child {
  margin-bottom: 0;
}

.Bqqpn1,
._RGIli {
  font-size: var(--type-label-md-font-size);
}

.Bqqpn1 {
  color: var(--text-neutral-dark);
  font-weight: var(--type-paragraph-lg-regular-font-weight);
  width: 130px;
}

._RGIli {
  color: var(--text-neutral-dark);
  font-weight: var(--type-label-md-font-weight);
}

.XDfmHw {
  all: unset;
  box-sizing: border-box;
  color: var(--ibk-colors-primary-orange-500, #d64000);
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-180);
  cursor: pointer;
  text-decoration: none;
  transition: opacity 0.2s ease;
  margin-left: var(--spacing-1);
}

.XDfmHw:hover {
  opacity: 0.8;
  text-decoration: underline;
}

.XDfmHw:focus {
  outline: 2px solid var(--border-primary-medium);
  outline-offset: 2px;
  border-radius: var(--radius-xs);
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/ParametersPage/components/ParametersSidebar/ParametersSidebar.module.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;EACxC,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,2DAA2D;EAC3D,qDAAqD;AACvD;;AAEA;EACE,+BAA+B;EAC/B,yCAAyC;EACzC,uCAAuC;EACvC,qDAAqD;EACrD,SAAS;AACX;;AAEA;EACE,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,iCAAiC;EACjC,yCAAyC;EACzC,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,gCAAgC;EAChC,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,4CAA4C;EAC5C,iCAAiC;AACnC;;AAEA;;EAEE,yCAAyC;EACzC,yDAAyD;EACzD,qDAAqD;AACvD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,8CAA8C;EAC9C,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B,yDAAyD;EACzD,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,oDAAoD;EACpD,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,mCAAmC;EACnC,eAAe;EACf,qBAAqB;EACrB,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,+CAA+C;EAC/C,mBAAmB;EACnB,+BAA+B;AACjC","sourcesContent":[".sidebarCard {\n  background: var(--surface-neutral-white);\n  border-radius: var(--radius-m);\n  box-shadow: var(--shadow-s);\n  height: calc(100vh - 155px);\n  min-height: 360px;\n  position: relative;\n}\n\n.sidebarHeader {\n  padding: var(--spacing-3) var(--spacing-3) var(--spacing-2);\n  border-bottom: 1px solid var(--stroke-neutral-subtle);\n}\n\n.sidebarTitle {\n  color: var(--text-neutral-dark);\n  font-size: var(--type-title-md-font-size);\n  font-weight: var(--font-weight-regular);\n  line-height: var(--type-label-lg-regular-line-height);\n  margin: 0;\n}\n\n.divider {\n  height: 1px;\n  background-color: var(--stroke-neutral-soft);\n}\n\n.sidebarContent {\n  padding: var(--spacing-3);\n}\n\n.summaryStep {\n  margin-bottom: var(--spacing-3);\n}\n\n.summaryStep:last-child {\n  margin-bottom: 0;\n}\n\n.summaryStepIndicator {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1-5);\n  margin-bottom: var(--spacing-2);\n}\n\n.stepIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: var(--spacing-3);\n  height: var(--spacing-3);\n}\n\n.stepIconActive,\n.stepIconInactive {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: var(--spacing-3);\n  height: var(--spacing-3);\n  border-radius: var(--spacing-1-5);\n  font-size: var(--type-label-md-font-size);\n  font-weight: var(--type-label-md-font-weight);\n  line-height: 1;\n}\n\n.stepIconActive {\n  background: var(--icon-primary-medium);\n  color: var(--text-neutral-white);\n  height: var(--spacing-3);\n  width: var(--spacing-3);\n}\n\n.stepIconCompleted {\n  color: var(--status-success);\n  height: var(--spacing-3);\n  width: var(--spacing-3);\n}\n\n.stepIconInactive {\n  background-color: transparent;\n  border: 1px solid var(--text-neutral-strong);\n  color: var(--text-neutral-strong);\n}\n\n.summaryStepTitle,\n.summaryStepTitleInactive {\n  font-size: var(--type-title-md-font-size);\n  font-weight: var(--type-paragraph-lg-regular-font-weight);\n  line-height: var(--type-label-lg-regular-line-height);\n}\n\n.summaryStepTitle {\n  color: var(--text-neutral-dark);\n}\n\n.summaryStepTitleInactive {\n  color: var(--disabled-subtle-text);\n}\n\n.summaryDivider {\n  height: 1px;\n  background-color: var(--stroke-neutral-subtle);\n  margin: var(--spacing-2) 0;\n}\n\n.activeCardInfo {\n  margin: var(--spacing-3) 0;\n}\n\n.activeCardData {\n  align-items: center;\n  display: flex;\n  margin-bottom: var(--spacing-1);\n}\n\n.activeCardData:last-child {\n  margin-bottom: 0;\n}\n\n.activeLabel,\n.activeValue {\n  font-size: var(--type-label-md-font-size);\n}\n\n.activeLabel {\n  color: var(--text-neutral-dark);\n  font-weight: var(--type-paragraph-lg-regular-font-weight);\n  width: 130px;\n}\n\n.activeValue {\n  color: var(--text-neutral-dark);\n  font-weight: var(--type-label-md-font-weight);\n}\n\n.viewBeneficiariesLink {\n  all: unset;\n  box-sizing: border-box;\n  color: var(--ibk-colors-primary-orange-500, #d64000);\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-180);\n  cursor: pointer;\n  text-decoration: none;\n  transition: opacity 0.2s ease;\n  margin-left: var(--spacing-1);\n}\n\n.viewBeneficiariesLink:hover {\n  opacity: 0.8;\n  text-decoration: underline;\n}\n\n.viewBeneficiariesLink:focus {\n  outline: 2px solid var(--border-primary-medium);\n  outline-offset: 2px;\n  border-radius: var(--radius-xs);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebarCard": `kLnVOI`,
	"sidebarHeader": `paTqWq`,
	"sidebarTitle": `Z_7cWv`,
	"divider": `yJsS5O`,
	"sidebarContent": `wLAnoX`,
	"summaryStep": `FMyVpu`,
	"summaryStepIndicator": `ioRCk4`,
	"stepIcon": `lMVIjF`,
	"stepIconActive": `iS1UXz`,
	"stepIconInactive": `UmcFkm`,
	"stepIconCompleted": `TE_RZe`,
	"summaryStepTitle": `oAfh2v`,
	"summaryStepTitleInactive": `RFUnRX`,
	"summaryDivider": `LDnB0W`,
	"activeCardInfo": `xO4_ZZ`,
	"activeCardData": `Tn6RtP`,
	"activeLabel": `Bqqpn1`,
	"activeValue": `_RGIli`,
	"viewBeneficiariesLink": `XDfmHw`
};
module.exports = ___CSS_LOADER_EXPORT___;
